module.exports  = {
  compare       : require('./compare')
  , method      : {
      'EuclideanDistance' : require('./method/euclidean-distance')
    , 'CIE76Difference'   : require('./method/cie-76-difference')
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/color-difference/lib/index.js
// module id = ZfdB
// module chunks = 11